const DAY_MS = 1000 * 60 * 60 * 24

/** "Submitted today", "Submitted 1 day ago" or "Submitted N days ago". */
export function formatSubmittedAgo(submittedAt: string, now: Date = new Date()): string {
  const diffDays = Math.floor((now.getTime() - new Date(submittedAt).getTime()) / DAY_MS)

  if (diffDays === 0) return 'Submitted today'
  if (diffDays === 1) return 'Submitted 1 day ago'
  return `Submitted ${diffDays} days ago`
}
